import React, { Fragment, useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import { Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { formikAddOrg, organizationTypeOption } from './Constant';
import { useDispatch, useSelector } from 'react-redux';
import TextInput from '../../components/InputFields/TextInput';
import { useFormik } from 'formik';
import { updateOrg } from '../../api/orgnizations';
import { failed, success } from '../../utils/Tostify';
import { useGetStates } from '../../hooks/useGetStates';

const EditOrgModal = ({ setShowModal, orgData, refetch }) => {
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const [file, setFile] = useState();
    const [Countryvalue, setCountryValue] = useState();
    const [stateValue, setStateValue] = useState();
    const dispatch = useDispatch();
    const { states, countryOptions } = useGetStates(Countryvalue);

    const formik = useFormik({
        ...formikAddOrg,
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                res = await updateOrg({ values, dispatch, token, orgId: orgData?._id });
                if (res?.status == "SUCCESS") {
                    refetch();
                    setIsLoading(false);
                    setShowModal(false);
                    success(res?.message);
                    formik.resetForm();
                }else{
                    setShowModal(false);
                    failed(res.message);
                    setIsLoading(false);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
                setShowModal(false);
            }
        }
    });

    const CountrychangeHandler = e => {
        setCountryValue(e.target.value);
        formik.setFieldValue("country", countryOptions.find((obj) => obj.value === e.target.value).label);
    };

    const stateHandler = (e) => {
        setStateValue(e.target.value);
        formik.setFieldValue('state', e.target.value);
    };

    useEffect(() => {
        formik.setFieldValue("orgName", orgData?.name);
        formik.setFieldValue("phone", orgData?.telecom.find((val) => val.system == "phone")?.value);
        formik.setFieldValue("email", orgData?.telecom.find((val) => val.system == "email")?.value);
        formik.setFieldValue("contactName", orgData?.contact?.[0]?.name);
        formik.setFieldValue("contactEmail", orgData?.contact?.[0]?.telecom.find((val) => val.system == "email")?.value);
        formik.setFieldValue("contactPhone", orgData?.contact?.[0]?.telecom.find((val) => val.system == "phone")?.value);
        formik.setFieldValue("address", orgData?.address?.[0]?.line[0]);
        formik.setFieldValue("postalCode", orgData?.address?.[0]?.postalCode);
        formik.setFieldValue("secondaryContactName", orgData?.contact?.[1]?.name);
        formik.setFieldValue("secondaryContactPhone", orgData?.contact?.[1]?.telecom.find((val) => val.system == "phone")?.value);
        formik.setFieldValue("secondarycontactEmail", orgData?.contact?.[1]?.telecom.find((val) => val.system == "email")?.value);
        formik.setFieldValue("city", orgData?.address?.[0]?.city);
        formik.setFieldValue("country", orgData?.address?.[0]?.country);
        formik.setFieldValue("type", orgData?.type);
        formik.setFieldValue("orgLogo", orgData.orgLogo);
        setCountryValue(countryOptions.find((obj) => obj.label === orgData?.address?.[0]?.country).value);
        formik.setFieldValue("state", orgData?.address?.[0]?.state);
        setStateValue(orgData?.address?.[0]?.state);
    }, [orgData]);

    useEffect(() => {
        if (setShowModal) {
          const modalBody = document.querySelector('.assign_modal_body');
          if (modalBody) {
            modalBody.scrollTop = 0;
          }
        }
      }, [setShowModal]);

    return (
        <Fragment>
            <Modal isOpen={setShowModal} toggle={setShowModal} size="xl" className='edit_modal_org'>
                <ModalHeader toggle={setShowModal} className="assign_blk p-0 mb-3">Edit Organization</ModalHeader>
                <Form onSubmit={formik.handleSubmit}>
                <ModalBody className="assign_modal_body">
                {isLoading ? <Loader /> : null}
                    <div className="organization_form_block organization_blk organization_modal modal_change_color p-4">
                        <div className="d-flex gap-4">
                            <div className="forms_block">
                                    <div className="first_block">
                                        <Row>
                                            <Col lg={6} className="location_block location_blk">
                                                <TextInput
                                                    keyField={"orgName"}
                                                    formik={formik}
                                                    label="Organization Name"
                                                    type="text"
                                                    placeholder="Name"
                                                    value={formik.values.orgName}
                                                    onChange={(e) => formik.setFieldValue("orgName", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block location_blk">
                                                <TextInput
                                                    keyField={"type"}
                                                    formik={formik}
                                                    label="Organization Type"
                                                    type="select"
                                                    options={organizationTypeOption}
                                                    value={formik.values.type}
                                                    onChange={(e) =>formik.setFieldValue("type", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"phone"}
                                                    formik={formik}
                                                    label="Organization Phone"
                                                    type="phone"
                                                    required={false}
                                                    placeholder="Phone"
                                                    value={formik.values.phone}
                                                    onChange={(e) => formik.setFieldValue("phone", e)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"email"}
                                                    formik={formik}
                                                    label="Organization Email"
                                                    type="text"
                                                    placeholder="Email"
                                                    value={formik.values.email}
                                                    onChange={(e) => formik.setFieldValue("email", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="first_block">
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <h6 className="block_name">Primary Contact Person</h6>
                                                <TextInput
                                                    keyField={"contactName"}
                                                    formik={formik}
                                                    label="Name"
                                                    type="text"
                                                    placeholder="Full Name"
                                                    value={formik.values.contactName}
                                                    onChange={(e) => formik.setFieldValue("contactName", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <h6 className="block_name">
                                                    Secondary Contact Person (Optional)
                                                </h6>
                                                <TextInput
                                                    keyField={"secondaryContactName"}
                                                    formik={formik}
                                                    label="Name"
                                                    type="text"
                                                    required={false}
                                                    placeholder="Full Name"
                                                    value={formik.values?.secondaryContactName}
                                                    onChange={(e) =>formik.setFieldValue("secondaryContactName", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"contactEmail"}
                                                    formik={formik}
                                                    label="Email"
                                                    type="email"
                                                    placeholder="Email"
                                                    value={formik.values.contactEmail}
                                                    onChange={(e) => formik.setFieldValue("contactEmail", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"secondarycontactEmail"}
                                                    formik={formik}
                                                    label="Email"
                                                    type="email"
                                                    placeholder="Email"
                                                    required={false}
                                                    value={formik.values.secondarycontactEmail}
                                                    onChange={(e) =>formik.setFieldValue("secondarycontactEmail", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"contactPhone"}
                                                    formik={formik}
                                                    label="Phone"
                                                    type="phone"
                                                    required={false}
                                                    placeholder="Phone"
                                                    value={formik.values.contactPhone}
                                                    onChange={(e) => formik.setFieldValue("contactPhone", e)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"secondaryContactPhone"}
                                                    formik={formik}
                                                    label="Phone"
                                                    type="phone"
                                                    placeholder="Phone"
                                                    required={false}
                                                    value={formik.values.secondaryContactPhone}
                                                    onChange={(e) => formik.setFieldValue("secondaryContactPhone", e)}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="first_block second_block">
                                        <h6 className="block_name">Address Information</h6>
                                        <Row>
                                            <Col lg={12} className="location_block">
                                                <TextInput
                                                    keyField={"address"}
                                                    formik={formik}
                                                    label="Street"
                                                    type="text"
                                                    placeholder="Street"
                                                    value={formik.values.address}
                                                    onChange={(e) => formik.setFieldValue("address", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"country"}
                                                    formik={formik}
                                                    options={countryOptions}
                                                    label="Country"
                                                    type="select"
                                                    placeholder="Country"
                                                    value={Countryvalue}
                                                    onChange={CountrychangeHandler}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"state"}
                                                    formik={formik}
                                                    label="State"
                                                    options={states.map((obj) => {
                                                        return {
                                                            label: obj.name,
                                                            value: obj.name
                                                        };
                                                    })}
                                                    type="select"
                                                    placeholder="State"
                                                    value={stateValue}
                                                    onChange={stateHandler}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"city"}
                                                    formik={formik}
                                                    label="City"
                                                    type="text"
                                                    placeholder="City"
                                                    value={formik.values.city}
                                                    onChange={(e) => formik.setFieldValue("city", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"postalCode"}
                                                    formik={formik}
                                                    label="Zip Code"
                                                    type="text"
                                                    placeholder="Zip Code"
                                                    value={formik.values.postalCode}
                                                    onChange={(e) => formik.setFieldValue("postalCode", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="p-0 mt-3">
                    <div className="d-flex justify-content-between">
                        <button className="save_btn" onClick={() => setShowModal(false)}>Close</button>
                        <button className="save_btn" type="submit">Save</button>
                    </div>
                </ModalFooter>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default EditOrgModal;
